// extracted by mini-css-extract-plugin
module.exports = {"orderDetails":"OrderDetails_orderDetails__SiWRR","row":"OrderDetails_row__34F_P","divider":"OrderDetails_divider__2S-Yu"};